import { Metadata_NumberCategory$reflection, Metadata_NumberCategory, Metadata_StringCategory$reflection, Metadata_StringCategory } from "../../../../Shared/Shared.js";
import { class_type } from "../../../../fable_modules/fable-library.3.7.9/Reflection.js";

export class Tid extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "tid";
    }
}

export function Tid$reflection() {
    return class_type("Corpora.Liatrebanken.MetadataCategories.Tid", void 0, Tid, Metadata_StringCategory$reflection());
}

export function Tid_$ctor_Z721C83C5(aName) {
    return new Tid(aName);
}

export class Alias extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "alias";
    }
}

export function Alias$reflection() {
    return class_type("Corpora.Liatrebanken.MetadataCategories.Alias", void 0, Alias, Metadata_StringCategory$reflection());
}

export function Alias_$ctor_Z721C83C5(aName) {
    return new Alias(aName);
}

export class Sex extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "sex";
    }
}

export function Sex$reflection() {
    return class_type("Corpora.Liatrebanken.MetadataCategories.Sex", void 0, Sex, Metadata_StringCategory$reflection());
}

export function Sex_$ctor_Z721C83C5(aName) {
    return new Sex(aName);
}

export class District1960 extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "district_1960";
    }
}

export function District1960$reflection() {
    return class_type("Corpora.Liatrebanken.MetadataCategories.District1960", void 0, District1960, Metadata_StringCategory$reflection());
}

export function District1960_$ctor_Z721C83C5(aName) {
    return new District1960(aName);
}

export class District1978 extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "district_1978";
    }
}

export function District1978$reflection() {
    return class_type("Corpora.Liatrebanken.MetadataCategories.District1978", void 0, District1978, Metadata_StringCategory$reflection());
}

export function District1978_$ctor_Z721C83C5(aName) {
    return new District1978(aName);
}

export class County extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "county";
    }
}

export function County$reflection() {
    return class_type("Corpora.Liatrebanken.MetadataCategories.County", void 0, County, Metadata_StringCategory$reflection());
}

export function County_$ctor_Z721C83C5(aName) {
    return new County(aName);
}

export class Owner extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "owner";
    }
}

export function Owner$reflection() {
    return class_type("Corpora.Liatrebanken.MetadataCategories.Owner", void 0, Owner, Metadata_StringCategory$reflection());
}

export function Owner_$ctor_Z721C83C5(aName) {
    return new Owner(aName);
}

export class RecYear extends Metadata_NumberCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "rec_year";
    }
}

export function RecYear$reflection() {
    return class_type("Corpora.Liatrebanken.MetadataCategories.RecYear", void 0, RecYear, Metadata_NumberCategory$reflection());
}

export function RecYear_$ctor_Z721C83C5(aName) {
    return new RecYear(aName);
}

export class AgeGroup extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "age_group";
    }
}

export function AgeGroup$reflection() {
    return class_type("Corpora.Liatrebanken.MetadataCategories.AgeGroup", void 0, AgeGroup, Metadata_StringCategory$reflection());
}

export function AgeGroup_$ctor_Z721C83C5(aName) {
    return new AgeGroup(aName);
}

export class Age extends Metadata_NumberCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "age";
    }
}

export function Age$reflection() {
    return class_type("Corpora.Liatrebanken.MetadataCategories.Age", void 0, Age, Metadata_NumberCategory$reflection());
}

export function Age_$ctor_Z721C83C5(aName) {
    return new Age(aName);
}

export class BirthYear extends Metadata_NumberCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "birth_year";
    }
}

export function BirthYear$reflection() {
    return class_type("Corpora.Liatrebanken.MetadataCategories.BirthYear", void 0, BirthYear, Metadata_NumberCategory$reflection());
}

export function BirthYear_$ctor_Z721C83C5(aName) {
    return new BirthYear(aName);
}

export class Place extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "place";
    }
}

export function Place$reflection() {
    return class_type("Corpora.Liatrebanken.MetadataCategories.Place", void 0, Place, Metadata_StringCategory$reflection());
}

export function Place_$ctor_Z721C83C5(aName) {
    return new Place(aName);
}

export class Occupation extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "occupation";
    }
}

export function Occupation$reflection() {
    return class_type("Corpora.Liatrebanken.MetadataCategories.Occupation", void 0, Occupation, Metadata_StringCategory$reflection());
}

export function Occupation_$ctor_Z721C83C5(aName) {
    return new Occupation(aName);
}

export class Filename extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "filename";
    }
}

export function Filename$reflection() {
    return class_type("Corpora.Liatrebanken.MetadataCategories.Filename", void 0, Filename, Metadata_StringCategory$reflection());
}

export function Filename_$ctor_Z721C83C5(aName) {
    return new Filename(aName);
}

export class OriginalFile extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "original_file";
    }
}

export function OriginalFile$reflection() {
    return class_type("Corpora.Liatrebanken.MetadataCategories.OriginalFile", void 0, OriginalFile, Metadata_StringCategory$reflection());
}

export function OriginalFile_$ctor_Z721C83C5(aName) {
    return new OriginalFile(aName);
}

export class Keywords extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "keywords";
    }
}

export function Keywords$reflection() {
    return class_type("Corpora.Liatrebanken.MetadataCategories.Keywords", void 0, Keywords, Metadata_StringCategory$reflection());
}

export function Keywords_$ctor_Z721C83C5(aName) {
    return new Keywords(aName);
}

export class Content extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "content";
    }
}

export function Content$reflection() {
    return class_type("Corpora.Liatrebanken.MetadataCategories.Content", void 0, Content, Metadata_StringCategory$reflection());
}

export function Content_$ctor_Z721C83C5(aName) {
    return new Content(aName);
}

export class Interviewer extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "interviewer";
    }
}

export function Interviewer$reflection() {
    return class_type("Corpora.Liatrebanken.MetadataCategories.Interviewer", void 0, Interviewer, Metadata_StringCategory$reflection());
}

export function Interviewer_$ctor_Z721C83C5(aName) {
    return new Interviewer(aName);
}

export class Comments1 extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "comments1";
    }
}

export function Comments1$reflection() {
    return class_type("Corpora.Liatrebanken.MetadataCategories.Comments1", void 0, Comments1, Metadata_StringCategory$reflection());
}

export function Comments1_$ctor_Z721C83C5(aName) {
    return new Comments1(aName);
}

export class Comments2 extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "comments2";
    }
}

export function Comments2$reflection() {
    return class_type("Corpora.Liatrebanken.MetadataCategories.Comments2", void 0, Comments2, Metadata_StringCategory$reflection());
}

export function Comments2_$ctor_Z721C83C5(aName) {
    return new Comments2(aName);
}

